import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import rootSaga from "./sagas";
import loaderReducer from "./Loader/slice";
import snackbarReducer from "./Snackbar/slice";
import authReducer from "./Auth/slice";
import localeReducer from "./Locale/slice";
import appHelpersReducer from "./AppHelpers/slice";
import userReducer from "./User/slice";
import lookupsReducer from "./Lookups/slice";
import rewardsReducer from "./Rewards/slice";
import tripsReducer from "./Trips/slice";
import verificationRequestsReducer from "./VerificationRequests/slice";
import adminsReducer from "./Admins/slice";
import referralsReducer from "./Referrals/slice";
import offersReducer from "./Offers/slice";
import animationsReducer from "./Animations/slice";
import servicesReducer from "./Services/slice";
import uploadReducer from "./Upload/slice";
import agentChatReducer from "./AgentChat/slice";
import challengesReducer from "./Challenges/slice";
const saga = createSagaMiddleware();

const store = configureStore({
  reducer: {
    loader: loaderReducer,
    snackbar: snackbarReducer,
    auth: authReducer,
    locale: localeReducer,
    appHelpers: appHelpersReducer,
    user: userReducer,
    lookups: lookupsReducer,
    rewards: rewardsReducer,
    trips: tripsReducer,
    verificationRequests: verificationRequestsReducer,
    admins: adminsReducer,
    referrals: referralsReducer,
    offers: offersReducer,
    animations: animationsReducer,
    services: servicesReducer,
    upload: uploadReducer,
    agentChat: agentChatReducer,
    challenges: challengesReducer,
  },
  middleware: [saga],
});

saga.run(rootSaga);

export default store;
